import { IconDrag } from '@components/icons';
import { InputCheckbox } from '@components/input-checkbox';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import classNames from 'classnames';

export interface AdmissionCardInteractiveProps {
  id: string;
  sectionClassName?: string;
  checked?: boolean;
  isDragActive?: boolean;
  isSelectActive?: boolean;
  isMultiSelectActive?: boolean;
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
  onChange?: (e: boolean) => void;
}

export const AdmissionCardInteractive = ({
  id,
  checked,
  sectionClassName,
  isDragActive = false,
  isSelectActive,
  isMultiSelectActive,
  listeners,
  attributes,
  onChange,
}: AdmissionCardInteractiveProps) => {
  const isSectionActive = !!isDragActive || !!isSelectActive || !!isMultiSelectActive;

  return (
    isSectionActive && (
      <div className={sectionClassName}>
        {isDragActive && (
          <div
            {...listeners}
            {...attributes}
            style={{ touchAction: 'none' }}
            className='flex items-start sm:items-center @sm:items-start sm:pr-4 @sm:pr-0 cursor-move'>
            <IconDrag className='text-tertiary w-5 h-5' />
          </div>
        )}
        {(isSelectActive || isMultiSelectActive) && (
          <div className={classNames('flex items-start sm:items-center @sm:items-start pr-1.5 sm:pr-4 @sm:pr-1.5')}>
            <InputCheckbox
              name={id}
              value={!!checked}
              type={isMultiSelectActive ? 'checkbox' : 'radio'}
              rounded={!isMultiSelectActive}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    )
  );
};
